export default {
  title: "Connections",
  view: {
    noItems: {
      title: "No connections yet",
      text: "Click to add a connection",
    },
  },
  input: {
    module: "Module",
    entity: "Entity",
    type: "Type",
  }

}
